const entityPlurals = {
  template: "templates",
  document: "documents",
}

const docusignUrl = process.env.DOCUSIGN_URL

export const buildEntityUrl = (entity, id) =>
  id ? `${docusignUrl}/${entityPlurals[entity]}/details/${id}` : null
